export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-16 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/7ceb0fe6-5632-411f-bdc4-bc51c645f0fc.png" 
              alt="Logo Em Breve"
              className="h-12 w-auto mb-6"
            />
            <p className="text-gray-400 text-sm leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
              O empreendimento mais exclusivo de Linhares. Sofisticação, conforto e valorização em um só lugar.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6" style={{ fontFamily: 'DM Serif Display, serif' }}>
              Contato
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
                <i className="ri-phone-line text-amber-600"></i>
                <span>(27) 99881-3443</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
                <i className="ri-mail-line text-amber-600"></i>
                <span>fernandes.vinicios@hotmail.com</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
                <i className="ri-map-pin-line text-amber-600"></i>
                <span>Três Barras, Linhares - ES</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6" style={{ fontFamily: 'DM Serif Display, serif' }}>
              Redes Sociais
            </h4>
            <div className="flex gap-4">
              <a 
                href="#" 
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-amber-600 transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-amber-600 transition-all duration-300 cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a 
                href="https://wa.me/5527999999999" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-amber-600 transition-all duration-300 cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
              © {currentYear} Em Breve. Todos os direitos reservados.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 text-sm hover:text-amber-600 transition-all duration-300 cursor-pointer"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
